module.exports = __webpack_public_path__ + "img/f4-1.f6450e05.png";